import { Box, Typography } from '@mui/material';

export default function PageHeader({ section, title, sx }) {
  return (
    <Box sx={sx}>
      {section && (
        <Typography variant="overline" color="primary" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
          {section}
        </Typography>
      )}
      <Typography variant="h4" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
        {title}
      </Typography>
    </Box>
  );
}
